function handles({ domain }) {
  return domain.startsWith('self.');
}

export default handles;



// WEBPACK FOOTER //
// ./src/components/SelfPost/handles.js